import React, { useEffect } from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import classes from "./layout.module.css";
import Templates from "./templates/templatesGrid";
import TemplateBuilder from "../Dock/templateBuilder/templateBuild";
import Button from "../Auth/button";
import Template from "./templates/template/template";
import axios from '../../Axios'
import Audit from "./AuditScreen/AuditScreen";
import AuditTemplate from "./templates/template/auditTemplate";
import Dashboard from "./Dashboard/dashboard";
import ActionPlan from "./ActionPlan/actionPlan";
import TeamManagement from "./TeamManagement/teamManagement";
import NewInspection from "./AuditScreen/newInspection/newInspection";
import { useSelector, useDispatch } from "react-redux";
// import ActionPlan from "./ActionPlan/actionPlan";
const Dock = ({ responses }) => {
  const dispatch = useDispatch();
  // const responseState = useSelector((state) => state.responses);
  useEffect(() => {
    const fetchFunc = async () => {
      const fetchData = await axios.post("/response/fetch", {
        fetchType: 0,
      });

      const { payload } = fetchData.data;
      if (payload) {
        dispatch({type: 'SEED_RESPONSES', fetchRes: payload})
      }
    };
    fetchFunc();
  }, []);

  let options = {
    dashboard: { link: "/dashBoard" },
    "team management": { link: "/team-manage" },
    audits: { link: "/audits" },
    templates: { link: "/templates" },
    //     "QA Kit": { link: "/qa-kit" },
    "action plans": { link: "/action-plans" },
    "template builder": { link: "/customize" },
  };

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };
  const click = () => {
    return null;
  };
  const menu = Object.keys(options).map((option) => {
    return (
      <NavLink
        className={classes.link}
        activeClassName={classes.active}
        to={options[option].link}
        key={option}
      >
        <div className={classes.dot}></div>
        {option}
      </NavLink>
    );
  });
  return (
    <div className={classes.layout}>
      <div className={classes.dock}>
        {/* <img
          alt="companyLogo"
          className={classes.logo}
          src="/images/logo_new.png"
        /> */}
        <div className={classes.block}>
          <div className={classes.userProfile}>
            <img
              alt="userImage"
              className={classes.userImage}
              src="/images/user.jpeg"
            ></img>
          </div>

          <div className={classes.name}>
            <span>{localStorage.getItem("name")}</span>
            <span>Role, {localStorage.getItem("company")}</span>
          </div>
        </div>
        <div className={classes.options}>{menu}</div>
      </div>

      <div className={classes.page}>
        <div className={classes.navBar}>
          <div className={classes.hamburger} onClick={click}>
            ☰
          </div>
          <div className={classes.inspectinity}>Digital Audits</div>
          <div>
            <Button onClick={logout} extraClass={classes.logout}>
              Logout
            </Button>
          </div>
        </div>
        <div className={classes.margin}>
          <Switch>
            <Route
              exact
              path="/templates"
              component={() => <Templates />}
            ></Route>
            <Route
              exact
              path="/dashBoard"
              component={() => < Dashboard />}
            ></Route>
            <Route
              exact
              path="/team-manage"
              component={() => <TeamManagement /> }
            ></Route>
            <Route exact path="/audits" component={() => <Audit />}></Route>
            <Route
              exact
              path="/qa-kits"
              component={() => <h1>qakits</h1>}
            ></Route>
            <Route
              exact
              path="/action-plans"
              component={() => <ActionPlan/>}
            ></Route>
            <Route
              exact
              path="/feedback"
              component={() => <h1>feedback</h1>}
            ></Route>
            <Route
              path="/customize"
              component={() => <TemplateBuilder responseList={responses} />}
            ></Route>
            <Route
              path="/view-template"
              component={() => <Template/>}
            ></Route>
            <Route
              path="/newInspection"
              component={() => <NewInspection />}
            ></Route>
            <Route
              path="/audit-template"
              component={() => <AuditTemplate />}
            ></Route>
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Dock;
